module.exports = __webpack_public_path__ + "img/account-btn.c5c8a7d0.png";